<div class="audio-player" [class.audio-player--playing]="isPlaying()">
  <button
    class="audio-player__control"
    (click)="togglePlayPause()"
    type="button"
    [attr.aria-label]="isPlaying() ? 'Pause audio' : 'Play audio'"
  >
    @if (isPlaying()) {
      <svg class="audio-player__pause-icon" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
        <rect x="4" y="4" width="4" height="12" rx="1" />
        <rect x="12" y="4" width="4" height="12" rx="1" />
      </svg>
    } @else {
      <svg class="audio-player__play-icon" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
        <path d="M6 4.5v11a1 1 0 001.56.827l8-5.5a1 1 0 000-1.654l-8-5.5A1 1 0 006 4.5z" />
      </svg>
    }
  </button>
  <div class="audio-player__waveform">
    @for (bar of waveformBars; track $index) {
      <span class="audio-player__bar" [style.height.%]="bar"></span>
    }
  </div>
  <span class="audio-player__time">
    {{ formatTime(displayDuration) }}
  </span>
  <audio #audioElement [src]="audioUrl()" preload="metadata"></audio>
</div>
